/* eslint-ignore */
import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import EditorFactory from 'wa.ui.editor';

import EditorContext from '../../context';
import EditorWindows from '../editor-windows';

class EditorContextProvider extends PureComponent
{
  static propTypes =
    {
      children: PropTypes.node.isRequired,
      blankPageUrl: PropTypes.string,
      showLinkStyleOption: PropTypes.bool,
      macros: PropTypes.shape({})
    };

  static defaultProps =
    {
      blankPageUrl: '',
      showLinkStyleOption: false,
      macros: null
    };

  constructor(props)
  {
    super(props);
    this.editor = EditorFactory();
    this.state = {};
  }

  componentWillUnmount()
  {
    this.editor = null;
  }

  render()
  {
    const { blankPageUrl, macros, showLinkStyleOption } = this.props;

    const value =
      {
        editor: this.editor,
        blankPageUrl,
        macros
      };

    const container = window.document.getElementById('idBonaEditorReactDialogsContainer');

    return (
      <EditorContext.Provider value={value}>
        {this.props.children}
        { container ?
          createPortal(<EditorWindows showLinkStyleOption={showLinkStyleOption} />, container) :
          (<EditorWindows showLinkStyleOption={showLinkStyleOption} />)}
      </EditorContext.Provider>
    );
  }
}

export default EditorContextProvider;